'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { startTokenRefresh, stopTokenRefresh } from '@/lib/auth';

export function AuthProvider() {
  const router = useRouter();

  useEffect(() => {
    // Start token refresh when component mounts
    startTokenRefresh();

    // Handle visibility changes
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        startTokenRefresh();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      stopTokenRefresh();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [router]);

  return null; // No DOM output
}